import system from './system';
import common from './common';
import order from './order';
import appUpgrade from './app-upgrade';

export default {
  ...system,
  ...common,
  ...order,
  ...appUpgrade
};
